import { render, staticRenderFns } from "./DashboardTabShareSettings.vue?vue&type=template&id=65a15986&scoped=true"
import script from "./DashboardTabShareSettings.vue?vue&type=script&lang=ts"
export * from "./DashboardTabShareSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a15986",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65a15986')) {
      api.createRecord('65a15986', component.options)
    } else {
      api.reload('65a15986', component.options)
    }
    module.hot.accept("./DashboardTabShareSettings.vue?vue&type=template&id=65a15986&scoped=true", function () {
      api.rerender('65a15986', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/DashboardTabShareSettings.vue"
export default component.exports